import { make } from "vuex-pathify"
import PixelsAPI from "@/api/pixels"

const state = () => {
  return {
    loading: false,
    pixels: [],
  }
}

const actions = {
  clearModule({ commit }) {
    commit("CLEAR_MODULE")
  },

  loadPixels({ commit, rootGetters, state }) {
    if (!state.pixels.length) {
      commit("SET_LOADING", true)

      const adAccountId = rootGetters["accounts/adAccountId"]

      return PixelsAPI.getAdAccountPixels(adAccountId)
        .then(response => {
          commit("SET_PIXELS", response)
        })
        .finally(() => {
          commit("SET_LOADING", false)
        })
    }
  },
}

const getters = {
  ...make.getters(state),
}

const mutations = {
  ...make.mutations(state),
  CLEAR_MODULE(state) {
    state.loading = false
    state.pixels = []
  },
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
